import { useMemo } from "react";
import { useAuth } from "@/shared/model/authContext";
import type { TenantModule } from "@/entities/tenant/@x/session";
import { useCurrentTenant } from "./useSessionTenants";

export type IsModuleContracted = (module: TenantModule) => boolean;

/**
 * Sem a lista (marca ainda a carregar, ou backend anterior aos módulos), tudo fica ligado:
 * esconder menus por falta de dado seria pior do que mostrá-los por um instante.
 */
export function contractedModulesPredicate(modules: readonly string[] | undefined): IsModuleContracted {
    if (!modules) return () => true;
    const contracted = new Set(modules);
    return (module) => contracted.has(module);
}

/** Módulos contratados pela organização da sessão (`/auth/me/tenant`); os essenciais não entram aqui. */
export function useContractedModules(): IsModuleContracted {
    const { isAuthenticated } = useAuth();
    const { data: tenant } = useCurrentTenant(isAuthenticated);
    const modules = tenant?.modules;
    return useMemo(() => contractedModulesPredicate(modules), [modules]);
}
